import React from "react";
import styled from "styled-components";
import { ColumnComponent } from "./Column";
import { StageElement } from "../../../types";

const RceRow = styled.div`
  position: relative;
  display: flex;
  width: 100%;
`;

interface RowProps {
  row: {
    columns?: Array<{
      stageElements?: StageElement[];
    }>;
  };
  renderStageElement: (element: StageElement, elementIndex: string) => JSX.Element | null;
}

export const RowComponent: React.FC<RowProps> = ({ row, renderStageElement }) => {
  if (!row.columns) {
    return null;
  }

  return (
    <RceRow className="spf-rce-row">
      {row.columns.map((column, position) => (
        <ColumnComponent
          key={`column-${position}`}
          column={column}
          renderStageElement={renderStageElement}
        />
      ))}
    </RceRow>
  );
};
